import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(isBetween);

/**
 * Equivalent of moment.parseZone(dateString): parses an ISO-ish string and
 * keeps the offset embedded in the string itself instead of converting to
 * the local/system timezone. dayjs has no built-in for this.
 */
export const parseZone = (dateString: string) => {
  const match = /([+-]\d{2}:?\d{2}|Z)$/.exec(dateString);
  let offsetMinutes = 0;
  if (match && match[1] !== 'Z') {
    const digits = match[1].slice(1).replace(':', '');
    const hours = Number(digits.slice(0, 2));
    const minutes = Number(digits.slice(2, 4));
    offsetMinutes = (match[1][0] === '-' ? -1 : 1) * (hours * 60 + minutes);
  }
  return dayjs.utc(dateString).utcOffset(offsetMinutes);
};

export default dayjs;
